module.exports = __webpack_public_path__ + "static/media/19.b5b91194.jpg";